import React, { Component } from 'react';
import AppRoute from './Routes';
import configCognito from './utils/amplify-config';
import { initReactGA } from './utils/analytics';
import navigator from './utils/navigator';
import 'bootstrap/dist/css/bootstrap.min.css';
import './log2base2.css';

navigator.sessionHandler();
configCognito();
initReactGA();

class App extends Component {
  render() {
    return <AppRoute />;
  }
}

export default App;
